import { render, staticRenderFns } from "./MusicWave.vue?vue&type=template&id=10177fd6&scoped=true&"
import script from "./MusicWave.vue?vue&type=script&lang=js&"
export * from "./MusicWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10177fd6",
  null
  
)

export default component.exports